import React from "react";
import {
  FormGroup,
  FormControl,
  ControlLabel,
  OverlayTrigger,
  Popover,
  Col,
} from "react-bootstrap";
import FormControlWrapper from "./FormControl";

const LegacyLabel = ({ label, hoverHelp }) => (
  <Col style={{ textAlign: "right" }} sm={4}>
    {label && <ControlLabel>{label}</ControlLabel>}
    {label && <span>&nbsp;</span>}
    {hoverHelp}
  </Col>
);

export const FieldGroup = ({
  id,
  groupClassName,
  helpText,
  hoverHelpText,
  validationState,
  label,
  colsWidth,
  ...props
}) => {
  const popover = <Popover id={id}>{hoverHelpText}</Popover>;
  const hoverHelp = hoverHelpText && (
    <OverlayTrigger
      trigger={["hover", "focus"]}
      placement="right"
      overlay={popover}
    >
      <span className={"label label-default"}>?</span>
    </OverlayTrigger>
  );
  const isLabelVisible = typeof label !== undefined;
  const labelCol = isLabelVisible && (
    <LegacyLabel label={label} hoverHelp={hoverHelp} />
  );
  const control = [
    <FormControlWrapper key="control-wrapper" id={id} {...props} />,
    // helpText && (<strong key="help-text">
    //     <small>
    //         <div className="text-color-form-control-help">{helpText}</div>
    //     </small>
    // </strong>),
    <FormControl.Feedback key="control-feedback" />,
  ];
  const controlCol = isLabelVisible && <Col sm={8}>{control}</Col>;
  if (colsWidth === undefined) {
    colsWidth = 12;
  }
  return (
    <Col sm={colsWidth}>
      <FormGroup
        controlId={id}
        className={groupClassName}
        validationState={validationState}
      >
        {labelCol}
        {controlCol}
      </FormGroup>
    </Col>
  );
};



// WEBPACK FOOTER //
// ./src/sc/ui/components/FieldGroup.js